import {Component, computed, input, inject} from '@angular/core';
import {CommonModule} from '@angular/common';
import {RouterModule} from '@angular/router';
import {DataService} from '../../../services/store/data.service';

/**
 * This component displays switch buttons from rota page to footfall predictions page and vice versa.
 */
@Component({
  selector: 'app-rota-page-switch',
  templateUrl: './rota-page-switch.component.html',
  styleUrls: ['./rota-page-switch.component.less'],
  imports: [CommonModule, RouterModule]
})
export class RotaPageSwitchComponent {

  private dataService = inject(DataService);

  /** A week identifier of a selected week. */
  weekId = input.required<string>();
  /** `True` if rota page is currently active. `False` if the currently active page is footfall predictions. */
  isActiveRotaPage = input.required<boolean>();

  /**
   * Checks if rota exists for the selected week.
   */
  rotaExist = computed(() => {
    return this.dataService.predictionRotaWeeks.find(week => week.id === this.weekId()).rotaExist;
  });
}